import { Box, Chip, Stack, Typography, Divider } from '@mui/material';

import { ButtonUI, DialogUI } from '../../Interface';
import jobmonitorEasyService from '../../../service/jobMonitorEasy.service';

const InfoField = ({ label, value }) => {
  if (!value) return null;

  return (
    <Box flex={1}>
      <Typography color="text.secondary" fontSize={13}>
        {label}
      </Typography>

      <Typography fontWeight={600}>{value}</Typography>
    </Box>
  );
};

const ActiveDowntimeDialog = ({ data, handleClose }) => {
  const hasDetails = data.projectName || data.articleName;

  const handleResume = () => {
    const values = {
      type: data.type,
      id: data.id,
      prodOperationId: data.prodOperationId,
      userId: data.userId,
    };

    jobmonitorEasyService.resumeFromDowntime(values).then(() => {
      handleClose();
    });
  };

  return (
    <DialogUI
      open
      onClose={handleClose}
      headerContent="Aktív állásidő"
      sx={{
        '& .MuiDialog-container': {
          '& .MuiPaper-root': {
            width: '100%',
            maxWidth: '750px',
            mx: 0.5,
          },
        },
        '& .MuiDialogContent-root': {
          px: 1,
        },
      }}
    >
      <Box
        sx={{
          background: '#f7fbff',
          border: '1px solid #d9eaf7',
          borderRadius: 2,
          p: 2,
          mt: 1,
        }}
      >
        <Stack direction="row" justifyContent="space-between" alignItems="center" gap={2}>
          <InfoField label="Művelet" value={data.activity} />

          <Chip
            label={data.downtimeReasonName}
            size="small"
            sx={{
              color: '#f84141',
              background: '#FDDDDD',
              fontWeight: 700,
            }}
          />
        </Stack>

        {hasDetails && <Divider sx={{ my: 2, background: '#d9eaf7' }} />}

        {hasDetails && (
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
            <InfoField label="Projekt" value={data.projectName} />
            <InfoField label="Cikknév" value={data.articleName} />
          </Stack>
        )}
      </Box>

      <Stack direction="row" justifyContent="center" spacing={1} mt={2}>
        <ButtonUI text="Folytatás" className="bg-success" onClick={handleResume} />
        <ButtonUI text="Mégse" className="bg-primary" onClick={handleClose} />
      </Stack>
    </DialogUI>
  );
};

export default ActiveDowntimeDialog;
